import validate from '../modules/validate';

validate();
